import { formatTagQualifier } from '@/components/search/query.ts'

/**
 * Route query for navigating to box search filtered by a tag.
 * Tags live in `query` as Tag:<key> and scope the whole box.
 */
export function getSearchByTagRouteQuery(
  tagKey: string,
  boxNodeId?: string,
): Record<string, string> {
  return {
    query: formatTagQualifier(tagKey),
    ...(boxNodeId ? { nodeId: boxNodeId } : {}),
  }
}
